export default __webpack_public_path__ + "static/media/tale07.640b9e44.png";